import PropTypes from 'prop-types';
import React from 'react';
import OutsideClick from '@gorangajic/react-outside-click';
import cx from 'classnames';
import { forEach, isBoolean, isEmpty } from 'lodash';
import withState from 'recompose/withState';
import styles from './Dropdown.css';

class Dropdown extends React.Component {
  constructor(props) {
    super(props);
    this.menuRef = React.createRef();
    this.triggerRef = React.createRef();
    this.state = { currentItem: 0, menuItems: [] };
  }

  getMenuItems = () =>
    (this.menuRef && this.menuRef.current && this.menuRef.current.querySelectorAll('a')) || [];

  setMenuItems = () => {
    const menuItems = this.getMenuItems();
    forEach(menuItems, menuItem => {
      menuItem.setAttribute('role', 'menuitem');
      menuItem.addEventListener('keydown', this.handleKeyDown);
      menuItem.addEventListener('click', () => this.toggleMenu(false));
    });
    if (!isEmpty(menuItems) && menuItems[0]) {
      setTimeout(() => menuItems[0].focus(), 0);
      this.setState({ currentItem: 0, menuItems });
    }
  }

  setMenuItemFocus = which => {
    const { currentItem, menuItems: stateMenuItems } = this.state;
    const menuItems = isEmpty(stateMenuItems)
      ? stateMenuItems
      : this.getMenuItems();
    const focusCurrent = current => {
      this.setState({ currentItem: current }, () => {
        if (!isEmpty(menuItems) && menuItems[currentItem]) {
          menuItems[current].focus();
        }
      });
    };
    const focusedItem = menuItems[currentItem];
    if (!focusedItem) return;
    focusedItem.blur();
    switch (which) {
      case 'prev':
        focusCurrent(
          currentItem === 0 ? menuItems.length - 1 : currentItem - 1,
        );
        break;
      case 'next':
        focusCurrent(
          currentItem === menuItems.length - 1 ? 0 : currentItem + 1,
        );
        break;
      case 'last':
        focusCurrent(menuItems.length - 1);
        break;
      case 'first':
      default:
        focusCurrent(0);
        break;
    }
  }

  unsetMenuItems = () => {
    const { menuItems } = this.state;
    forEach(menuItems, menuItem => {
      menuItem.removeEventListener('keydown', this.handleKeyDown);
    });
    this.setState({ menuItems: [], currentItem: 0 });
  }

  handleKeyDown = e => {
    const { open } = this.props;
    const { menuItems: stateMenuItems } = this.state;
    const menuItems = isEmpty(stateMenuItems)
      ? stateMenuItems
      : this.getMenuItems();
    if (open && menuItems && menuItems.length > 0) {
      e.preventDefault();
      switch (e.code) {
        case 'Escape':
        case 'Tab':
          this.toggleMenu(false);
          break;
        case 'ArrowUp':
          this.setMenuItemFocus('prev');
          break;
        case 'ArrowDown':
          this.setMenuItemFocus('next');
          break;
        case 'Home':
          this.setMenuItemFocus('first');
          break;
        case 'End':
          this.setMenuItemFocus('last');
          break;
        case 'Enter':
          if (e.target.click) e.target.click();
          e.stopPropagation();
          this.toggleMenu(false);
          break;
        default: break;
      }
    }
  }

  toggleMenu = (toOpen = null) => {
    const { open, toggle } = this.props;
    const toggleTo = isBoolean(toOpen) ? toOpen : !open;
    toggle(toggleTo);
    if (toggleTo) {
      this.setMenuItems();
    } else {
      this.unsetMenuItems();
      if (this.triggerRef && this.triggerRef.current) {
        this.triggerRef.current.focus();
      }
    }
  }

  render() {
    const {
      open,
      button,
      label,
      dropdownClassName = '',
      children,
    } = this.props;
    return (
      <OutsideClick onOutsideClick={() => open && this.toggleMenu(false)}>
        <div
          className={cx(styles.dropdown, {
            [styles.active]: open,
          })}
        >
          {
            React.cloneElement(button, {
              ref: this.triggerRef,
              onClick: () => this.toggleMenu(),
              className: cx(button.props.className, styles.dropdownLink),
              'aria-label': label,
              'aria-haspopup': 'true',
              'aria-expanded': open ? 'true' : 'false',
            })
          }
          <div
            role="menu"
            className={cx(styles.dropdownMenu, dropdownClassName)}
            ref={this.menuRef}
          >
            {children}
          </div>
        </div>
      </OutsideClick>);
  }
}

Dropdown.propTypes = {
  label: PropTypes.string,
  button: PropTypes.node,
  children: PropTypes.node,
  open: PropTypes.bool,
  toggle: PropTypes.func,
  dropdownClassName: PropTypes.string,
};

export default withState('open', 'toggle', false)(Dropdown);



// WEBPACK FOOTER //
// ./src/client/Components/Dropdown/Dropdown.js